var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "invite-tab-root",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c("div", { staticClass: "invite-search right-read" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.hostId,
              expression: "hostId",
            },
          ],
          attrs: { placeholder: _vm.$t("lang.invite.inputPlaceholder") },
          domProps: { value: _vm.hostId },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.hostId = $event.target.value
            },
          },
        }),
        _c("img", {
          attrs: { src: require("../images/search.png"), alt: "" },
          on: { click: _vm.handleSearch },
        }),
      ]),
      _vm.info.actInviteBeanReward &&
      _vm.info.actInviteStartTimeStamp &&
      _vm.info.actInviteEndTimeStamp
        ? _c(
            "div",
            {
              staticClass: "invite-card right-read",
              on: { click: _vm.handleLearnMore },
            },
            [
              _c("MyPLabel", {
                staticClass: "card-info",
                attrs: {
                  str: _vm.$t("lang.newInvite.k010"),
                  numsOption: [
                    { value: _vm.info.actInviteBeanReward, style: "" },
                  ],
                  customClass: { bean: "invite-bean" },
                },
              }),
              _c("div", { staticClass: "card-bottom" }, [
                _c("div", { staticClass: "date-interval" }, [
                  _vm._v(
                    _vm._s(
                      _vm.handleMoment(
                        _vm.info.actInviteStartTimeStamp,
                        "DD/MM/YYYY"
                      )
                    ) +
                      " - " +
                      _vm._s(
                        _vm.handleMoment(
                          _vm.info.actInviteEndTimeStamp,
                          "DD/MM/YYYY"
                        )
                      )
                  ),
                ]),
                _c("button", { staticClass: "learn-more" }, [
                  _vm._v(_vm._s(_vm.$t("lang.newInvite.k011"))),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "invite-list right-read" },
        [
          _c("div", { staticClass: "switch-tab" }, [
            _c(
              "div",
              {
                staticClass: "tab",
                class: { "active-tab": _vm.inviteTabIndex == 0 },
                on: {
                  click: function ($event) {
                    return _vm.handelInviteTab(0)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("lang.all")))]
            ),
            _c(
              "div",
              {
                staticClass: "tab",
                class: { "active-tab": _vm.inviteTabIndex == 1 },
                on: {
                  click: function ($event) {
                    return _vm.handelInviteTab(1)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("lang.dl.thisWeek")))]
            ),
            _c(
              "div",
              {
                staticClass: "tab",
                class: { "active-tab": _vm.inviteTabIndex == 2 },
                on: {
                  click: function ($event) {
                    return _vm.handelInviteTab(2)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("lang.host.lastWeek")))]
            ),
          ]),
          _c(
            "div",
            { staticClass: "amount-block", attrs: { id: "invite-target-aa" } },
            [
              _c("div", { staticClass: "amount-item" }, [
                _c("div", { staticClass: "amount-title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.dl.totalHostess"))),
                ]),
                _c("span", { staticClass: "amount-count" }, [
                  _vm._v(_vm._s(_vm.totalHostess)),
                ]),
              ]),
              _c("div", { staticClass: "amount-item" }, [
                _c("div", { staticClass: "amount-title" }, [
                  _vm._v(_vm._s(_vm.$t("lang.inRule.inviteBonus"))),
                ]),
                _c("span", { staticClass: "amount-count" }, [
                  _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                  _vm._v(" " + _vm._s(_vm.inviteBonus) + " "),
                ]),
              ]),
              _c("div", { staticClass: "deliver-line" }),
            ]
          ),
          _vm.newGuyGuide.show
            ? [
                _c("div", { staticClass: "info-card" }, [
                  _c("img", {
                    staticClass: "avatar-left",
                    attrs: { src: _vm.imgPath },
                  }),
                  _c("div", { staticClass: "info-right" }, [
                    _c("div", { staticClass: "text-row" }, [
                      _c("span", { staticClass: "text-left" }, [
                        _vm._v(" Elizabeth "),
                        _c("img", {
                          staticClass: "country-icon",
                          attrs: { src: _vm.imgPath },
                        }),
                      ]),
                      _c("span", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.$t("lang.newInvite.k049"))),
                      ]),
                    ]),
                    _vm._m(0),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "status-item",
                    attrs: { id: "invite-target-ab" },
                  },
                  [
                    _c("div", { staticClass: "status-line" }),
                    _c("div", { staticClass: "status-card" }, [
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _vm._m(1),
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done-kiko.png"),
                                  alt: "",
                                },
                              })
                            : _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done.png"),
                                  alt: "",
                                },
                              }),
                        ]),
                      ]),
                      _c("div", { staticClass: "status-step" }, [
                        _c("div", { staticClass: "step-icon" }, [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                attrs: {
                                  src: require("../images/status-step2-kiko.png"),
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../images/status-step2.png"),
                                },
                              }),
                        ]),
                        _vm.packageName === "kiko"
                          ? _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking-kiko.png"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking.png"),
                                alt: "",
                              },
                            }),
                        _c("span", { staticClass: "beans-num" }, [
                          _vm._v(" 200 "),
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("beans-off") },
                          }),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                          _c("img", {
                            staticClass: "status-icon",
                            attrs: {
                              src: require("../images/status-fail.png"),
                              alt: "",
                            },
                          }),
                          _c("span", { staticClass: "beans-num underline" }, [
                            _vm._v(" 1000 "),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans-off") },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._l(_vm.hosts, function (item, index) {
            return _c("div", { key: index, staticClass: "van-clearfix" }, [
              _c("div", { staticClass: "info-card" }, [
                _c("img", {
                  staticClass: "avatar-left",
                  attrs: { src: _vm._f("imgPath")(item.avatar) },
                }),
                _c("div", { staticClass: "info-right" }, [
                  _c("div", { staticClass: "text-row" }, [
                    _c("span", { staticClass: "text-left" }, [
                      _vm._v(" " + _vm._s(item.nickname) + " "),
                      _c("img", {
                        staticClass: "country-icon",
                        attrs: { src: _vm._f("imgPath")(item.locationFlag) },
                      }),
                    ]),
                    _c("span", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.$t("lang.newInvite.k049"))),
                    ]),
                  ]),
                  _c("div", { staticClass: "num-row" }, [
                    _c(
                      "span",
                      {
                        staticClass: "num-left",
                        on: {
                          click: function ($event) {
                            return _vm.handleCopyId(item)
                          },
                        },
                      },
                      [
                        _vm._v(" ID: " + _vm._s(item.presentId) + " "),
                        _c("img", {
                          staticClass: "copy-icon",
                          attrs: { src: require("../images/copy-gray.png") },
                        }),
                      ]
                    ),
                    _c("span", { staticClass: "num-left" }, [
                      _vm._v(
                        _vm._s(_vm.handleMoment(item.createTime, "DD/MM/YYYY"))
                      ),
                    ]),
                  ]),
                ]),
              ]),
              item.ifShowTaskProcess
                ? _c("div", { staticClass: "status-item" }, [
                    _c("div", { staticClass: "status-line" }),
                    _c(
                      "div",
                      {
                        staticClass: "status-card",
                        style: `justify-content: ${
                          item.activityTaskState
                            ? "space-around"
                            : "space-between"
                        }`,
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "status-step" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "step-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.showTips(
                                        $event,
                                        item.verifiedTip
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../images/status-step1.png"),
                                    },
                                  }),
                                ]
                              ),
                              item.verifyState === 1
                                ? [
                                    _vm.packageName === "kiko"
                                      ? _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-done-kiko.png"),
                                            alt: "",
                                          },
                                        })
                                      : _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-done.png"),
                                            alt: "",
                                          },
                                        }),
                                  ]
                                : _vm._e(),
                              item.verifyState === 2
                                ? [
                                    _vm.packageName === "kiko"
                                      ? _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-checking-kiko.png"),
                                            alt: "",
                                          },
                                        })
                                      : _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-checking.png"),
                                            alt: "",
                                          },
                                        }),
                                  ]
                                : _vm._e(),
                              item.verifyState === 3
                                ? _c("img", {
                                    staticClass: "status-icon",
                                    attrs: {
                                      src: require("../images/status-fail.png"),
                                      alt: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                        item.activityTaskState
                          ? _c(
                              "div",
                              { staticClass: "status-step" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "step-icon",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showTips(
                                          $event,
                                          item.commonTaskTip
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm.packageName === "kiko"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("../images/status-step2-kiko.png"),
                                          },
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src: require("../images/status-step2.png"),
                                          },
                                        }),
                                  ]
                                ),
                                item.commonTaskState === 1
                                  ? [
                                      _vm.packageName === "kiko"
                                        ? _c("img", {
                                            staticClass: "status-icon",
                                            attrs: {
                                              src: require("../images/status-done-kiko.png"),
                                              alt: "",
                                            },
                                          })
                                        : _c("img", {
                                            staticClass: "status-icon",
                                            attrs: {
                                              src: require("../images/status-done.png"),
                                              alt: "",
                                            },
                                          }),
                                      _c(
                                        "span",
                                        { staticClass: "beans-num highline" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.commRewardBeans) +
                                              " "
                                          ),
                                          _c("img", {
                                            attrs: {
                                              src: _vm.getMatchImg("beans"),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                item.commonTaskState === 2
                                  ? [
                                      _vm.packageName === "kiko"
                                        ? _c("img", {
                                            staticClass: "status-icon",
                                            attrs: {
                                              src: require("../images/status-checking-kiko.png"),
                                              alt: "",
                                            },
                                          })
                                        : _c("img", {
                                            staticClass: "status-icon",
                                            attrs: {
                                              src: require("../images/status-checking.png"),
                                              alt: "",
                                            },
                                          }),
                                      _c("span", { staticClass: "beans-num" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.commRewardBeans) +
                                            " "
                                        ),
                                        _c("img", {
                                          attrs: {
                                            src: _vm.getMatchImg("beans-off"),
                                          },
                                        }),
                                      ]),
                                    ]
                                  : _vm._e(),
                                item.commonTaskState === 3
                                  ? [
                                      _c("img", {
                                        staticClass: "status-icon",
                                        attrs: {
                                          src: require("../images/status-fail.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "beans-num underline" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.commRewardBeans) +
                                              " "
                                          ),
                                          _c("img", {
                                            attrs: {
                                              src: _vm.getMatchImg("beans-off"),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "status-step" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "step-icon",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.showTips(
                                            $event,
                                            item.commonTaskTip
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.packageName === "kiko"
                                        ? _c("img", {
                                            attrs: {
                                              src: require("../images/status-step2-kiko.png"),
                                            },
                                          })
                                        : _c("img", {
                                            attrs: {
                                              src: require("../images/status-step2.png"),
                                            },
                                          }),
                                    ]
                                  ),
                                  item.commonTaskState === 1
                                    ? [
                                        _vm.packageName === "kiko"
                                          ? _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-done-kiko.png"),
                                                alt: "",
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-done.png"),
                                                alt: "",
                                              },
                                            }),
                                        _c(
                                          "span",
                                          { staticClass: "beans-num highline" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.commRewardBeans) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg("beans"),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  item.commonTaskState === 2
                                    ? [
                                        _vm.packageName === "kiko"
                                          ? _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-checking-kiko.png"),
                                                alt: "",
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-checking.png"),
                                                alt: "",
                                              },
                                            }),
                                        _c(
                                          "span",
                                          { staticClass: "beans-num" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.commRewardBeans) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg(
                                                  "beans-off"
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  item.commonTaskState === 3
                                    ? [
                                        _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-fail.png"),
                                            alt: "",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "beans-num underline",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.commRewardBeans) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg(
                                                  "beans-off"
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                        item.activityTaskState
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "status-step" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "step-icon",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.showTips(
                                            $event,
                                            item.activityTaskTip
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.getMatchImg("beans"),
                                        },
                                      }),
                                    ]
                                  ),
                                  item.activityTaskState === 1
                                    ? [
                                        _vm.packageName === "kiko"
                                          ? _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-done-kiko.png"),
                                                alt: "",
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-done.png"),
                                                alt: "",
                                              },
                                            }),
                                      ]
                                    : _vm._e(),
                                  item.activityTaskState === 2
                                    ? [
                                        _vm.packageName === "kiko"
                                          ? _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-checking-kiko.png"),
                                                alt: "",
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "status-icon",
                                              attrs: {
                                                src: require("../images/status-checking.png"),
                                                alt: "",
                                              },
                                            }),
                                      ]
                                    : _vm._e(),
                                  item.activityTaskState === 3
                                    ? [
                                        _c("img", {
                                          staticClass: "status-icon",
                                          attrs: {
                                            src: require("../images/status-fail.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  item.activityTaskState === 1
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "beans-num highline" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.activityRewardBeans
                                                ) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg("beans"),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  item.activityTaskState === 2
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "beans-num" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.activityRewardBeans
                                                ) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg(
                                                  "beans-off"
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  item.activityTaskState === 3
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "beans-num underline",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.activityRewardBeans
                                                ) +
                                                " "
                                            ),
                                            _c("img", {
                                              attrs: {
                                                src: _vm.getMatchImg(
                                                  "beans-off"
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          }),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "is-loading" },
                [_c("van-loading", { attrs: { size: "24px" } })],
                1
              )
            : _vm._e(),
          _vm.finished
            ? _c("div", { staticClass: "no-more" }, [
                _vm._v(_vm._s(_vm.$t("lang.noMore"))),
              ])
            : _vm._e(),
          _c("InviteSearch", {
            attrs: { showDia: _vm.showSearchDia, hostDate: _vm.searchHostData },
          }),
          _c("ConfirmAuto", {
            attrs: {
              showDia: _vm.removeConfirmAutoDia,
              title: _vm.removeTitle,
              content: _vm.removeContent,
              leftBtnText: _vm.leftBtnText,
              rightBtnText: _vm.rightBtnText,
            },
            on: { leftBtn: _vm.removeLeftBtn, rightBtn: _vm.removeRightBtn },
          }),
          _vm.tipsInfo.show
            ? _c("TipOnclick", {
                attrs: {
                  position: _vm.tipsInfo.position,
                  text: _vm.tipsInfo.text,
                  direction: _vm.tipsInfo.direction,
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "newguy-guide",
              attrs: { id: "guide-step1" },
              on: {
                click: function ($event) {
                  return _vm.handleGuideClick(1)
                },
              },
            },
            [
              _c("div", { staticClass: "step3" }, [
                _c("div", { staticClass: "newguy-guide-tips" }, [
                  _c("div", { staticClass: "tips-content" }, [
                    _c("div", { staticClass: "tips-title right-align" }, [
                      _vm._v(_vm._s(_vm.$t("lang.newInvite.k044"))),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "amount-block",
                    attrs: { id: "invite-guide-aa" },
                  },
                  [
                    _c("div", { staticClass: "amount-item" }, [
                      _c("div", { staticClass: "amount-title" }, [
                        _vm._v(_vm._s(_vm.$t("lang.dl.totalHostess"))),
                      ]),
                      _c("span", { staticClass: "amount-count" }, [
                        _vm._v("10"),
                      ]),
                    ]),
                    _c("div", { staticClass: "amount-item" }, [
                      _c("div", { staticClass: "amount-title" }, [
                        _vm._v(_vm._s(_vm.$t("lang.inRule.inviteBonus"))),
                      ]),
                      _c("span", { staticClass: "amount-count" }, [
                        _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                        _vm._v(" 2000 "),
                      ]),
                    ]),
                    _c("div", { staticClass: "deliver-line" }),
                  ]
                ),
                _c("div", { staticClass: "btn-wrap" }, [
                  _c("div", { staticClass: "newguy-guide-btn" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleGuideClick(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k050")))]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "newguy-guide",
              attrs: { id: "guide-step2" },
              on: {
                click: function ($event) {
                  return _vm.handleGuideClick(2)
                },
              },
            },
            [
              _c("div", { staticClass: "step1AndStep2" }, [
                _c("div", { staticClass: "btn-wrap" }, [
                  _c("div", { staticClass: "newguy-guide-btn" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            if ($event.target !== $event.currentTarget)
                              return null
                            return _vm.handleGuideClick(2)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k050")))]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "newguy-guide-tips" }, [
                  _c("div", { staticClass: "tips-content" }, [
                    _c("p", { staticClass: "tips-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.newInvite.k036"))),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../images/status-step1.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k037")) + " "),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _vm.packageName === "kiko"
                        ? _c("img", {
                            attrs: {
                              src: require("../images/status-step2-kiko.png"),
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("../images/status-step2.png"),
                            },
                          }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k038")) + " "),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _c("img", {
                        attrs: { src: _vm.getMatchImg("beans"), alt: "" },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k039")) + " "),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "status-item",
                    attrs: { id: "invite-guide-ab" },
                  },
                  [
                    _c("div", { staticClass: "status-line" }),
                    _c("div", { staticClass: "status-card" }, [
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _vm._m(2),
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done-kiko.png"),
                                  alt: "",
                                },
                              })
                            : _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done.png"),
                                  alt: "",
                                },
                              }),
                        ]),
                      ]),
                      _c("div", { staticClass: "status-step" }, [
                        _c("div", { staticClass: "step-icon" }, [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                attrs: {
                                  src: require("../images/status-step2-kiko.png"),
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../images/status-step2.png"),
                                },
                              }),
                        ]),
                        _vm.packageName === "kiko"
                          ? _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking-kiko.png"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking.png"),
                                alt: "",
                              },
                            }),
                        _c("span", { staticClass: "beans-num" }, [
                          _vm._v(" 200 "),
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("beans-off") },
                          }),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                          _c("img", {
                            staticClass: "status-icon",
                            attrs: {
                              src: require("../images/status-fail.png"),
                              alt: "",
                            },
                          }),
                          _c("span", { staticClass: "beans-num underline" }, [
                            _vm._v(" 1000 "),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans-off") },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "newguy-guide",
              attrs: { id: "guide-step3" },
              on: {
                click: function ($event) {
                  return _vm.handleGuideClick(3)
                },
              },
            },
            [
              _c("div", { staticClass: "step1AndStep2" }, [
                _c("div", { staticClass: "btn-wrap" }, [
                  _c("div", { staticClass: "newguy-guide-btn" }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.handleGuideClick(3)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("lang.newInvite.k050")))]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "newguy-guide-tips" }, [
                  _c("div", { staticClass: "tips-content" }, [
                    _c("p", { staticClass: "tips-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.newInvite.k040"))),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _vm.packageName === "kiko"
                        ? _c("img", {
                            attrs: {
                              src: require("../images/status-done-kiko.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("../images/status-done.png"),
                              alt: "",
                            },
                          }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k041")) + " "),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _vm.packageName === "kiko"
                        ? _c("img", {
                            attrs: {
                              src: require("../images/status-checking-kiko.png"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: require("../images/status-checking.png"),
                              alt: "",
                            },
                          }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k042")) + " "),
                    ]),
                    _c("div", { staticClass: "tips-item" }, [
                      _c("img", {
                        attrs: {
                          src: require("../images/status-fail.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k043")) + " "),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "status-item",
                    attrs: { id: "invite-guide-bb" },
                  },
                  [
                    _c("div", { staticClass: "status-line" }),
                    _c("div", { staticClass: "status-card" }, [
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _vm._m(3),
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done-kiko.png"),
                                  alt: "",
                                },
                              })
                            : _c("img", {
                                staticClass: "status-icon",
                                attrs: {
                                  src: require("../images/status-done.png"),
                                  alt: "",
                                },
                              }),
                        ]),
                      ]),
                      _c("div", { staticClass: "status-step" }, [
                        _c("div", { staticClass: "step-icon" }, [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                attrs: {
                                  src: require("../images/status-step2-kiko.png"),
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../images/status-step2.png"),
                                },
                              }),
                        ]),
                        _vm.packageName === "kiko"
                          ? _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking-kiko.png"),
                                alt: "",
                              },
                            })
                          : _c("img", {
                              staticClass: "status-icon",
                              attrs: {
                                src: require("../images/status-checking.png"),
                                alt: "",
                              },
                            }),
                        _c("span", { staticClass: "beans-num" }, [
                          _vm._v(" 200 "),
                          _c("img", {
                            attrs: { src: _vm.getMatchImg("beans-off") },
                          }),
                        ]),
                      ]),
                      _c("div", [
                        _c("div", { staticClass: "status-step" }, [
                          _c("div", { staticClass: "step-icon" }, [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                          _c("img", {
                            staticClass: "status-icon",
                            attrs: {
                              src: require("../images/status-fail.png"),
                              alt: "",
                            },
                          }),
                          _c("span", { staticClass: "beans-num underline" }, [
                            _vm._v(" 1000 "),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans-off") },
                            }),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
        ],
        2
      ),
      _c("div", { staticStyle: { height: "450px" } }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "num-row" }, [
      _c("span", { staticClass: "num-left" }, [
        _vm._v(" ID: 100040 "),
        _c("img", {
          staticClass: "copy-icon",
          attrs: { src: require("../images/copy-gray.png") },
        }),
      ]),
      _c("span", { staticClass: "num-left" }, [_vm._v("30/04/2025")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", { attrs: { src: require("../images/status-step1.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", { attrs: { src: require("../images/status-step1.png") } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "step-icon" }, [
      _c("img", { attrs: { src: require("../images/status-step1.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }